import { Button, Col, Flex, Modal, Row, Typography } from "antd";
import { useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import StationeryCard from "../../hrm/HrmStationeryCard";
import { notify } from "../../../utils/toast";
import { AxiosError } from "axios";
import { useCreateStationeryRequestItems } from "../../../query/HrmQuery";
import { ICreateStationeryRequestItem } from "../../../models/Hrm";

interface ModalAddStationeryItemsProps {
  isOpen: boolean;
  onClose: (open: boolean) => void;
  reqId: number;
}

const ModalAddStationeryItems = ({
  isOpen,
  onClose,
  reqId,
}: ModalAddStationeryItemsProps) => {
  const mutation = useCreateStationeryRequestItems();
  const [stationeryArray, setStationeryArray] = useState<
    Partial<ICreateStationeryRequestItem>[]
  >([]);

  const isSubmitDisabled =
    reqId === 0 ||
    stationeryArray.length === 0 ||
    stationeryArray.some(
      (item) => !item.productId || !item.quantity || item.quantity <= 0,
    );

  return (
    <Modal
      title="Thêm văn phòng phẩm"
      open={isOpen}
      onCancel={() => onClose(false)}
      width={1000}
      footer={[
        <Button
          key="cancel"
          onClick={() => {
            onClose(false);
          }}
        >
          Đóng
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={mutation.isPending}
          onClick={async () => {
            try {
              await mutation.mutateAsync({
                requestId: reqId,
                payload: stationeryArray,
              });
              notify.success("Thêm văn phòng phẩm thành công");
              setStationeryArray([
                { productId: undefined, note: "", quantity: 1 },
              ]);
              onClose(false);
            } catch (error: unknown) {
              const err = error as AxiosError<{ message: string }>;
              notify.error(
                err.response?.data.message || "Thêm văn phòng phẩm thất bại",
              );
            }
          }}
          disabled={isSubmitDisabled}
        >
          Lưu
        </Button>,
      ]}
    >
      <Flex vertical gap="middle">
        <Flex
          align="center"
          justify="space-between"
          gap="small"
          className="w-full pb-2 border-b "
        >
          <Typography.Text strong style={{ minWidth: 24 }}>
            STT
          </Typography.Text>
          <Row
            gutter={8}
            className="w-full text-sm"
            style={{ flex: 1, fontWeight: 600 }}
          >
            <Col span={8}>Tên văn phòng phẩm</Col>
            <Col span={8}>Số lượng</Col>
            <Col span={8}>Ghi chú</Col>
          </Row>
        </Flex>

        {stationeryArray.map((item, index) => (
          <Flex key={index} align="start" gap="small" className="w-full">
            <Typography.Text
              strong
              className=" pt-1.5"
              style={{ minWidth: 24 }}
            >
              {index + 1}.
            </Typography.Text>
            <StationeryCard
              index={index}
              item={item}
              isValid={() => {}}
              onChange={(index, updatedData) => {
                setStationeryArray((prev) => {
                  return prev.map((item, idx) =>
                    idx === index ? updatedData : item,
                  );
                });
              }}
              onDelete={(index) => {
                setStationeryArray((prev) => {
                  return prev.filter((item, idx) => idx !== index);
                });
              }}
            />
          </Flex>
        ))}
      </Flex>

      <Button
        type="primary"
        block
        icon={<PlusOutlined />}
        className="mt-4"
        onClick={() => {
          setStationeryArray((prev) => {
            return [...prev, { note: "", quantity: 1, productId: undefined }];
          });
        }}
      >
        Thêm vật phẩm
      </Button>
    </Modal>
  );
};

export default ModalAddStationeryItems;
